import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=c2c40eb0"
import script from "./FaqItem.vue?vue&type=script&lang=ts"
export * from "./FaqItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports